/**
 * „Nebeneinander" für die beiden Geschosszahlen (Auftraggeber, 19.08.2026).
 *
 * Die zwei `GeschossStepper` („Über Erdgleiche" / „Unter Erdgleiche") sind die
 * beiden Hälften EINER Frage und standen bisher untereinander. Sie stehen jetzt
 * in zwei Spalten, sobald der Platz reicht — und in einer, sobald er nicht mehr
 * reicht.
 *
 * **Der Umbruch richtet sich nach der Breite des Containers, nicht nach der des
 * Viewports.** Das ist hier kein Feinschliff, sondern die eigentliche
 * Anforderung: dieses Formular läuft auch in einem schwebenden Fenster
 * (Startbreite 1140 px, bis auf 420 px herunterziehbar). Der Viewport bleibt
 * dabei breit, der Inhaltsbereich nicht. Eine Viewport-Media-Query — wie sie
 * `QuestionDef.layout: "two"` in `risikoanalyseStep/QuestionBlock.tsx` über
 * `@media (min-width: 720px)` benutzt — lieferte im geschrumpften Fenster zwei
 * Spalten in einem ~350 px schmalen Bereich. Genau dieser Schaden ist in
 * `BauartklassePicker.tsx` protokolliert; von dort stammt auch das Mittel:
 * `repeat(auto-fit, minmax(…, 1fr))`. Das Raster misst sich selbst, ganz ohne
 * `ResizeObserver` und ohne `@container` (beides gibt es in diesem Formular
 * nicht).
 *
 * Warum 340 px Untergrenze:
 *   Die Inhaltsspalte ist auf 920 px gedeckelt (`RisikoImmobilieStepForm`,
 *   Stil `inner`). Bei 16 px Spaltenabstand bleiben je Spalte 452 px — zwei
 *   Spalten sind also klar erreichbar. Eine Stepper-Zeile besteht aus Bild
 *   (68 px, ab 480 px Viewport 88 px) + 16 px + Zahl/Beschriftung + 16 px +
 *   44 px Zähler; unter rund 340 px wird die Beschriftung („Unter Erdgleiche
 *   (Keller)") zwischen Bild und Zähler zerquetscht. Die Zeile selbst ist
 *   ohnehin auf 420 px gedeckelt (`GeschossStepper`, Stil `zeile`), breiter
 *   werden die Spalten also nicht.
 *
 * `min(340px, 100%)` statt `340px` ist Absicht: unterschreitet der Container
 * die 340 px, liefe ein blankes `minmax(340px, 1fr)` über den rechten Rand
 * hinaus, statt auf eine Spalte zu fallen.
 */
import type { CSSProperties } from "react";

/** Untergrenze einer Spalte. Darunter fällt das Raster auf eine Spalte. */
export const GESCHOSS_PAAR_MIN_PX = 340;

export const geschossPaarStil: CSSProperties = {
  display: "grid",
  gridTemplateColumns: `repeat(auto-fit, minmax(min(${GESCHOSS_PAAR_MIN_PX}px, 100%), 1fr))`,
  columnGap: "16px",
  // Der bisherige Abstand der untereinander stehenden Zeilen — er gilt jetzt
  // nur noch, wenn das Raster tatsächlich umbricht.
  rowGap: "6px",
  alignItems: "start",
};

/** Kennzeichnung des Rasters für Tests. */
export const GESCHOSS_PAAR_TESTID = "geschoss-paar";
